import { type Anomaly, type AnomalyAPIResponse } from '@gozoki/api-types';

import { gozokiAiApi } from '../gozokiApi';

export function createAnomalyLink(storeId: string, videoId: string, startTime: string): string {
    return `https://ia-video-stream-staging.lucie-la-cabane-autonome.fr/stream/stores/${storeId}/video/${videoId}&starttime=${startTime}`;
    // TODO : hide the AI backend link
}

export function createAnomaly(
    anomalyTypeId: number,
    temporaryLink: string,
    link: string | null,
    id: string,
    timestamp: string
): Anomaly {
    const anomaly = ANOMALY_DETAILS[anomalyTypeId] || UNKNOWN_ANOMALY;
    return {
        name: anomaly.name,
        color: anomaly.color,
        link,
        temporaryLink,
        id,
        anomalyTypeId: anomalyTypeId.toString(),
        timestamp,
    };
}

export const fetchAnomalies = async (storeId: string) => {
    const response = await gozokiAiApi.get<{ alerts: AnomalyAPIResponse[] }>(
        `/stores/${storeId}/alerts`
    );
    if (Array.isArray(response.data?.alerts)) {
        return response.data.alerts.map((a) => {
            return createAnomaly(
                Number.parseInt(a.anomalyTypeId, 10),
                createAnomalyLink(storeId, a.videoId, a.startTime),
                a.link,
                a.id,
                a.timestamp
            );
        });
    }
    return [];
};

const ANOMALY_RED = '#e53935';
const ANOMALY_GRAY = '#1E2637';

export const ANOMALY_DETAILS = [
    { name: 'Blocage en caisse', color: ANOMALY_RED },
    { name: 'Client allongé', color: ANOMALY_GRAY },
    { name: 'Trop de monde', color: ANOMALY_GRAY },
    { name: 'Geste Suspicieux', color: ANOMALY_GRAY },
    { name: 'Agitation', color: ANOMALY_GRAY },
    { name: 'Incohérence panier', color: ANOMALY_RED },
    { name: 'Chien', color: ANOMALY_GRAY },
    { name: 'Trotinette électrique', color: ANOMALY_GRAY },
    { name: 'Vélo', color: ANOMALY_GRAY },
    { name: 'Degradation', color: ANOMALY_GRAY },
    { name: "Blocage à l'entrée", color: ANOMALY_GRAY },
];

export const UNKNOWN_ANOMALY = {
    name: 'Anomalie inconnue',
    color: ANOMALY_GRAY,
};
